import { render, staticRenderFns } from "./XCPage.vue?vue&type=template&id=c56f2254&scoped=true&"
import script from "./XCPage.vue?vue&type=script&lang=js&"
export * from "./XCPage.vue?vue&type=script&lang=js&"
import style0 from "./XCPage.vue?vue&type=style&index=0&id=c56f2254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f2254",
  null
  
)

export default component.exports